import { logger } from "./logger";
import { getVoiceLang } from "./voicePref";
// Ikuti Lampu Ajaib - Simon Says / Memory Pattern Game Data

export const SIMON_THEMES = {
  warna: {
    name: "Warna",
    items: [
      { id: "red", label: "Merah", color: "#EF4444", activeColor: "#FCA5A5", icon: null },
      { id: "blue", label: "Biru", color: "#3B82F6", activeColor: "#93C5FD", icon: null },
      { id: "yellow", label: "Kuning", color: "#EAB308", activeColor: "#FDE047", icon: null },
      { id: "green", label: "Hijau", color: "#22C55E", activeColor: "#86EFAC", icon: null },
      { id: "purple", label: "Ungu", color: "#A855F7", activeColor: "#D8B4FE", icon: null },
      { id: "orange", label: "Oranye", color: "#F97316", activeColor: "#FDBA74", icon: null },
    ],
  },
  bentuk: {
    name: "Bentuk",
    items: [
      { id: "circle", label: "Lingkaran", color: "#EF4444", activeColor: "#FCA5A5", icon: "●" },
      { id: "star", label: "Bintang", color: "#EAB308", activeColor: "#FDE047", icon: "★" },
      { id: "triangle", label: "Segitiga", color: "#3B82F6", activeColor: "#93C5FD", icon: "▲" },
      { id: "square", label: "Persegi", color: "#22C55E", activeColor: "#86EFAC", icon: "■" },
      { id: "diamond", label: "Belah Ketupat", color: "#A855F7", activeColor: "#D8B4FE", icon: "◆" },
      { id: "heart", label: "Hati", color: "#EC4899", activeColor: "#F9A8D4", icon: "♥" },
    ],
  },
  angka: {
    name: "Angka",
    items: [
      { id: "n1", label: "1", color: "#EF4444", activeColor: "#FCA5A5", icon: "1" },
      { id: "n2", label: "2", color: "#3B82F6", activeColor: "#93C5FD", icon: "2" },
      { id: "n3", label: "3", color: "#22C55E", activeColor: "#86EFAC", icon: "3" },
      { id: "n4", label: "4", color: "#EAB308", activeColor: "#FDE047", icon: "4" },
      { id: "n5", label: "5", color: "#A855F7", activeColor: "#D8B4FE", icon: "5" },
      { id: "n6", label: "6", color: "#F97316", activeColor: "#FDBA74", icon: "6" },
    ],
  },
  hewan: {
    name: "Hewan",
    items: [
      { id: "cat", label: "Kucing", color: "#F97316", activeColor: "#FDBA74", icon: "🐱", sound: "Meow!" },
      { id: "dog", label: "Anjing", color: "#92400E", activeColor: "#D97706", icon: "🐶", sound: "Guk guk!" },
      { id: "cow", label: "Sapi", color: "#22C55E", activeColor: "#86EFAC", icon: "🐮", sound: "Mooo!" },
      { id: "chicken", label: "Ayam", color: "#EAB308", activeColor: "#FDE047", icon: "🐔", sound: "Kukuruyuk!" },
      { id: "duck", label: "Bebek", color: "#3B82F6", activeColor: "#93C5FD", icon: "🦆", sound: "Kwek kwek!" },
      { id: "frog", label: "Kodok", color: "#16A34A", activeColor: "#4ADE80", icon: "🐸", sound: "Koak koak!" },
    ],
  },
};

export const SIMON_LEVELS = [
  {
    id: 1, name: "2 Warna", icon: "🔴", color: "#EF4444",
    desc: "Ingat urutan 2 warna!", theme: "warna",
    buttonCount: 4, startLen: 2, maxLen: 4, showSpeed: 1000, lives: 99,
  },
  {
    id: 2, name: "3 Warna", icon: "🟢", color: "#22C55E",
    desc: "Urutan mulai lebih panjang!", theme: "warna",
    buttonCount: 4, startLen: 3, maxLen: 6, showSpeed: 900, lives: 99,
  },
  {
    id: 3, name: "Bentuk Dasar", icon: "⭐", color: "#EAB308",
    desc: "Ingat urutan bentuk!", theme: "bentuk",
    buttonCount: 4, startLen: 2, maxLen: 5, showSpeed: 950, lives: 99,
  },
  {
    id: 4, name: "Angka Berurutan", icon: "🔢", color: "#3B82F6",
    desc: "Ingat urutan angka!", theme: "angka",
    buttonCount: 6, startLen: 3, maxLen: 6, showSpeed: 850, lives: 99,
  },
  {
    id: 5, name: "Hewan Bersuara", icon: "🐾", color: "#F97316",
    desc: "Dengar dan ingat suara hewan!", theme: "hewan",
    buttonCount: 4, startLen: 2, maxLen: 5, showSpeed: 1000, lives: 99,
  },
  {
    id: 6, name: "Super Memori", icon: "🧠", color: "#A855F7",
    desc: "Urutan panjang, tempo santai!", theme: "warna",
    buttonCount: 6, startLen: 4, maxLen: 10, showSpeed: 750, lives: 99,
  },
  {
    id: 7, name: "Hewan Cepat", icon: "\uD83D\uDC0E", color: "#16A34A",
    desc: "Hewan dengan tempo lebih cepat!", theme: "hewan",
    buttonCount: 6, startLen: 3, maxLen: 8, showSpeed: 700, lives: 99,
  },
  {
    id: 8, name: "Angka Panjang", icon: "\uD83D\uDD22", color: "#0EA5E9",
    desc: "Urutan angka sampai 8 langkah!", theme: "angka",
    buttonCount: 6, startLen: 4, maxLen: 8, showSpeed: 750, lives: 99,
  },
  {
    id: 9, name: "Bentuk Ekstra", icon: "\u2728", color: "#D946EF",
    desc: "Semua bentuk dengan tempo cepat!", theme: "bentuk",
    buttonCount: 6, startLen: 4, maxLen: 9, showSpeed: 700, lives: 99,
  },
  {
    id: 10, name: "Legenda Memori", icon: "\uD83C\uDFC6", color: "#DC2626",
    desc: "Tantangan tertinggi - 12 langkah!", theme: "warna",
    buttonCount: 6, startLen: 5, maxLen: 12, showSpeed: 600, lives: 99,
  },
];

// Play a tone for a button
const FREQ_MAP = {
  0: 261.63, 1: 329.63, 2: 392.00, 3: 523.25, 4: 587.33, 5: 659.25,
};

export const playButtonTone = (index) => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.type = "sine";
    osc.frequency.value = FREQ_MAP[index % 6] || 440;
    gain.gain.setValueAtTime(0.15, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.35);
    osc.start(); osc.stop(ctx.currentTime + 0.35);
  } catch (err) { logger.debug("audio op failed", err); }
};

export const playWrongTone = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.type = "sawtooth";
    osc.frequency.setValueAtTime(200, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(80, ctx.currentTime + 0.4);
    gain.gain.setValueAtTime(0.1, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
    osc.start(); osc.stop(ctx.currentTime + 0.4);
  } catch (err) { logger.debug("audio op failed", err); }
};

export const playSuccessFanfare = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [523, 659, 784, 1047].forEach((f, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination);
      osc.frequency.value = f;
      gain.gain.setValueAtTime(0.12, ctx.currentTime + i * 0.12);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + i * 0.12 + 0.25);
      osc.start(ctx.currentTime + i * 0.12);
      osc.stop(ctx.currentTime + i * 0.12 + 0.25);
    });
  } catch (err) { logger.debug("audio op failed", err); }
};

export const speakAnimalSound = (text) => {
  try {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(text);
      u.lang = getVoiceLang(); u.rate = 0.85; u.pitch = 1.0;
      window.speechSynthesis.speak(u);
    }
  } catch (err) { logger.debug("audio op failed", err); }
};
